import React from "react";

import { RadioGroup } from "@headlessui/react";

export type RadioOption = {
  key: string;
  name: string;
  content?: React.ReactNode;
  disabled?: boolean;
};
type RadioButtonsProps = {
  label?: string;
  options: RadioOption[];
  selectedOption?: RadioOption;
  setSelectedOption: React.Dispatch<any>;
  className?: string;
  error?: string;
  disabled?: boolean;
};
const RadioButtons = ({
  label,
  options,
  selectedOption,
  setSelectedOption,
  className,
  error,
  disabled = false,
}: RadioButtonsProps) => {
  return (
    <RadioGroup className={className} value={selectedOption} onChange={setSelectedOption} disabled={disabled}>
      {label && <RadioGroup.Label className="block text-sm font-medium text-gray-700 mb-1">{label}</RadioGroup.Label>}
      <div className="-space-y-px rounded-md bg-white divide-y border border-gray-200">
        {options.map((option, idx) => (
          <RadioGroup.Option
            key={option.name}
            value={option}
            disabled={option.disabled === true}
            className={`${idx === 0 ? "rounded-tl-md rounded-tr-md" : ""} ${
              idx === options.length - 1 ? "rounded-bl-md rounded-br-md" : ""
            } relative p-4 flex cursor-pointer focus:outline-none`}
          >
            {({ active, checked }) => (
              <>
                <span
                  className={`${checked ? "bg-emerald-600 border-transparent" : "bg-white"} ${
                    active ? "ring-2 ring-offset-2 ring-emerald-500" : ""
                  } mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded-full border flex items-center justify-center`}
                  aria-hidden="true"
                >
                  <span className="rounded-full bg-white w-1.5 h-1.5" />
                </span>
                <div className="ml-3 flex flex-col w-11/12">
                  <RadioGroup.Label
                    as="span"
                    className={`${
                      checked ? "text-emerald-700" : option.disabled ? "text-gray-400" : "text-gray-900"
                    } block text-sm font-medium`}
                  >
                    {option.name}
                  </RadioGroup.Label>
                  {checked && <div className="mt-1">{option.content}</div>}
                </div>
              </>
            )}
          </RadioGroup.Option>
        ))}
      </div>
      {error && <p className="mt-1 text-xs font-medium text-red-600">{error}</p>}
    </RadioGroup>
  );
};

export default RadioButtons;
